/**
 * Generic 404 page.
 *
 * Important: this route MUST NOT acknowledge or hint at sensitive paths
 * (`/admin`, `/caldera`, etc). Render a clean generic 404 with the same
 * copy regardless of which unknown path the user hit — never include the
 * attempted path in the visible UI.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-sarathi-background flex items-center justify-center px-6">
      <div className="max-w-md text-center" data-testid="not-found-page">
        <p className="font-outfit text-7xl font-bold text-sarathi-primary mb-3">404</p>
        <h1 className="font-outfit text-2xl font-semibold text-white mb-3">
          Page not found
        </h1>
        <p className="text-sarathi-text-secondary text-sm mb-8">
          The page you were looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-sarathi-primary hover:bg-sarathi-primary-hover text-white px-5 py-2.5 rounded-full font-semibold text-sm transition-colors"
          data-testid="not-found-home-link"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>
      </div>
    </div>
  );
}
